module.exports = __webpack_public_path__ + "porownanie2.png?e9fb760853a89dae692dcdf0652301cf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/porownanie2.png
// module id = 8
// module chunks = 0